// #region Imports
import { safeNumber } from '../../../shared/helpers';
// #endregion

// #region Builders
export function buildCliente(partial = {}) {
  return {
    id: partial.id ?? null,
    nome: partial.nome ?? '',
    cpf: partial.cpf ?? '',
    telefone: partial.telefone ?? '',
    sexo: partial.sexo ?? '',
    data_nascimento: partial.data_nascimento ?? '',
    saldo_devedor: safeNumber(partial.saldo_devedor),
    observacoes: partial.observacoes ?? '',
  };
}
// #endregion

// #region Mapeadores
export function clienteFromJSON(json = {}) { return buildCliente(json); }
export function clienteFromBackend(dto = {}) {
  return buildCliente({
    id: dto.id,
    nome: dto.nome,
    cpf: dto.cpf,
    telefone: dto.telefone,
    sexo: dto.sexo,
    data_nascimento: dto.data_nascimento || dto.dataNascimento || '',
    saldo_devedor: dto.saldo_devedor ?? dto.saldoDevedor ?? 0,
    observacoes: dto.observacoes ?? dto.notes ?? '',
  });
}
// #endregion

// #region Serialização
export function clienteToJSON(cliente) { return { ...cliente }; }
// #endregion
